'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stubFalse2 = require('lodash/stubFalse');

var _stubFalse3 = _interopRequireDefault(_stubFalse2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mightyFields = require('../../../lib/mighty-fields');

var _util = require('../../../utils/util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var GenericFundingFormModal = (_dec = (0, _mobxReact.inject)('UiStore', 'LienStore', 'OptionsStore', 'CaseStore', 'FunderStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(GenericFundingFormModal, _Component);

  function GenericFundingFormModal() {
    _classCallCheck(this, GenericFundingFormModal);

    return _possibleConstructorReturn(this, (GenericFundingFormModal.__proto__ || Object.getPrototypeOf(GenericFundingFormModal)).apply(this, arguments));
  }

  _createClass(GenericFundingFormModal, [{
    key: 'onSave',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(formData) {
        var _props, _case, LienStore, CaseStore, lienData, caseData, isCaseValueUpdated, promises;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, _case = _props._case, LienStore = _props.LienStore, CaseStore = _props.CaseStore, lienData = _extends({}, formData, { case: _case.id, subtype: { name: formData.subtype } }), caseData = { value: formData.estimated_case_value }, isCaseValueUpdated = _case.value !== caseData.value;


                if (!lienData.subtype.name) {
                  lienData.subtype = null;
                }

                this.onClose();

                promises = [LienStore.createOrUpdateGenericLien(lienData)];

                if (isCaseValueUpdated) {
                  promises.push(CaseStore.update({ caseId: _case.id, data: caseData }));
                }
                _context.next = 7;
                return Promise.all(promises);

              case 7:
                if (!isCaseValueUpdated) {
                  _context.next = 10;
                  break;
                }

                _context.next = 10;
                return LienStore.list({ caseId: _case.id });

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSave(_x) {
        return _ref.apply(this, arguments);
      }

      return onSave;
    }()
  }, {
    key: 'onClose',
    value: function onClose() {
      var _props2 = this.props,
          UiStore = _props2.UiStore,
          onClose = _props2.onClose;

      onClose();
      UiStore.modals.GenericFundingForm.close();
    }
  }, {
    key: 'render',
    value: function render() {
      var isFinanceCustomer = this.props.FunderStore.isFinanceCustomer;


      return _react2.default.createElement(_mightyFields.FormModal, {
        className: 'form-generic-funding',
        fieldSets: GenericFundingFormModal.fieldSets(isFinanceCustomer),
        model: this.lienData,
        onClose: this.onClose,
        onSave: this.onSave,
        title: 'New Lien'
      });
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }, {
    key: 'lienData',
    get: function get() {
      var _props3 = this.props,
          lien = _props3.lien,
          _case = _props3._case,
          data = { estimated_case_value: _case.value };


      if (!lien) {
        return data;
      }

      return _extends({}, lien, data, { subtype: (0, _get3.default)(lien, 'subtype.name') });
    }
  }], [{
    key: 'fieldSets',
    value: function fieldSets() {
      var isFinanceCustomer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      return [[{
        field: 'id',
        type: 'hidden',
        writeOnly: true
      }, {
        field: 'estimated_case_value',
        required: true,
        type: 'money'
      }, {
        canChangeType: false,
        field: 'ownership_percentage',
        percentOf: 'estimated_case_value',
        required: true,
        type: 'percentMoney'
      }, {
        field: 'acquired_date',
        type: 'date'
      }, {
        field: 'subtype',
        optionType: 'genericLienTypes',
        type: 'optionSelect'
      }, {
        field: 'notes',
        type: 'text'
      }].concat(_toConsumableArray((0, _util.insertIf)(isFinanceCustomer, {
        field: 'is_available_to_coop',
        label: 'Available To CoOp Capital',
        required: true,
        type: 'boolean'
      })))];
    }
  }]);

  return GenericFundingFormModal;
}(_react.Component), _class2.defaultProps = {
  onClose: _stubFalse3.default
}, _class2.propTypes = {
  _case: _propTypes2.default.object,
  CaseStore: _propTypes2.default.object,
  FunderStore: _propTypes2.default.object,
  lien: _propTypes2.default.object,
  LienStore: _propTypes2.default.object,
  onClose: _propTypes2.default.func,
  OptionsStore: _propTypes2.default.object,
  UiStore: _propTypes2.default.object
}, _temp)) || _class) || _class) || _class);
var _default = GenericFundingFormModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(GenericFundingFormModal, 'GenericFundingFormModal', '/app/src/components/page-case/main-fundings/GenericFundingFormModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-fundings/GenericFundingFormModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9jb21wb25lbnRzL3BhZ2UtY2FzZS9tYWluLWZ1bmRpbmdzL0dlbmVyaWNGdW5kaW5nRm9ybU1vZGFsLmpzIl0sIm5hbWVzIjpbIkdlbmVyaWNGdW5kaW5nRm9ybU1vZGFsIiwiYXV0b0JpbmRNZXRob2RzIiwib2JzZXJ2ZXIiLCJmb3JtRGF0YSIsInByb3BzIiwiX2Nhc2UiLCJMaWVuU3RvcmUiLCJDYXNlU3RvcmUiLCJsaWVuRGF0YSIsImNhc2UiLCJpZCIsInN1YnR5cGUiLCJuYW1lIiwiY2FzZURhdGEiLCJ2YWx1ZSIsImVzdGltYXRlZF9jYXNlX3ZhbHVlIiwiaXNDYXNlVmFsdWVVcGRhdGVkIiwib25DbG9zZSIsInByb21pc2VzIiwiY3JlYXRlT3JVcGRhdGVHZW5lcmljTGllbiIsInB1c2giLCJ1cGRhdGUiLCJjYXNlSWQiLCJkYXRhIiwiUHJvbWlzZSIsImFsbCIsImxpc3QiLCJVaVN0b3JlIiwibW9kYWxzIiwiR2VuZXJpY0Z1bmRpbmdGb3JtIiwiY2xvc2UiLCJpc0ZpbmFuY2VDdXN0b21lciIsIkZ1bmRlclN0b3JlIiwiZmllbGRTZXRzIiwib25TYXZlIiwibGllbiIsImZpZWxkIiwidHlwZSIsIndyaXRlT25seSIsInJlcXVpcmVkIiwiY2FuQ2hhbmdlVHlwZSIsInBlcmNlbnRPZiIsIm9wdGlvblR5cGUiLCJsYWJlbCIsIkNvbXBvbmVudCIsImRlZmF1bHRQcm9wcyIsInByb3BUeXBlcyIsIlByb3BUeXBlcyIsIm9iamVjdCIsImZ1bmMiLCJPcHRpb25zU3RvcmUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7QUFDQTs7OztBQUNBOztBQUNBOzs7O0FBR0E7O0FBQ0E7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0lBS01BLHVCLFdBSEwsdUJBQU8sU0FBUCxFQUFrQixXQUFsQixFQUErQixjQUEvQixFQUErQyxXQUEvQyxFQUE0RCxhQUE1RCxDLG9CQUNBQyxnQyxlQUNBQyxtQjs7Ozs7Ozs7Ozs7OzBGQUVlQyxROzs7Ozs7O3lCQUM0QixLQUFLQyxLLEVBQXJDQyxLLFVBQUFBLEssRUFBT0MsUyxVQUFBQSxTLEVBQVdDLFMsVUFBQUEsUyxFQUN0QkMsUSxnQkFBZ0JMLFEsSUFBVU0sTUFBTUosTUFBTUssRSxFQUFJQyxTQUFTLEVBQUVDLE1BQU1ULFNBQVNRLE9BQWpCLEUsS0FDbkRFLFEsR0FBVyxFQUFFQyxPQUFPWCxTQUFTWSxvQkFBbEIsRSxFQUNYQyxrQixHQUFxQlgsTUFBTVMsS0FBTixLQUFnQkQsU0FBU0MsSzs7O0FBRWxELG9CQUFJLENBQUNOLFNBQVNHLE9BQVQsQ0FBaUJDLElBQXRCLEVBQTRCO0FBQUVKLDJCQUFTRyxPQUFULEdBQW1CLElBQW5CO0FBQTBCOztBQUV4RCxxQkFBS00sT0FBTDs7QUFFTUMsd0IsR0FBVyxDQUFDWixVQUFVYSx5QkFBVixDQUFvQ1gsUUFBcEMsQ0FBRCxDOztBQUNqQixvQkFBSVEsa0JBQUosRUFBd0I7QUFBRUUsMkJBQVNFLElBQVQsQ0FBY2IsVUFBVWMsTUFBVixDQUFpQixFQUFFQyxRQUFRakIsTUFBTUssRUFBaEIsRUFBb0JhLE1BQU1WLFFBQTFCLEVBQWpCLENBQWQ7QUFBd0U7O3VCQUM1RlcsUUFBUUMsR0FBUixDQUFZUCxRQUFaLEM7OztxQkFFRkYsa0I7Ozs7Ozt1QkFBNEJWLFVBQVVvQixJQUFWLENBQWUsRUFBRUosUUFBUWpCLE1BQU1LLEVBQWhCLEVBQWYsQzs7Ozs7Ozs7Ozs7Ozs7Ozs7OzhCQXVEdkI7QUFBQSxvQkFDb0IsS0FBS04sS0FEekI7QUFBQSxVQUNEdUIsT0FEQyxXQUNEQSxPQURDO0FBQUEsVUFDUVYsT0FEUixXQUNRQSxPQURSOztBQUVUQTtBQUNBVSxjQUFRQyxNQUFSLENBQWVDLGtCQUFmLENBQWtDQyxLQUFsQztBQUNEOzs7NkJBRVM7QUFBQSxVQUNlQyxpQkFEZixHQUN1QyxLQUFLM0IsS0FENUMsQ0FDQTRCLFdBREEsQ0FDZUQsaUJBRGY7OztBQUdSLGFBQ0UsOEJBQUMsdUJBQUQ7QUFDRSxtQkFBVSxzQkFEWjtBQUVFLG1CQUFXL0Isd0JBQXdCaUMsU0FBeEIsQ0FBa0NGLGlCQUFsQyxDQUZiO0FBR0UsZUFBTyxLQUFLdkIsUUFIZDtBQUlFLGlCQUFTLEtBQUtTLE9BSmhCO0FBS0UsZ0JBQVEsS0FBS2lCLE1BTGY7QUFNRSxlQUFNO0FBTlIsUUFERjtBQVVEOzs7Ozs7Ozs7O3dCQXZFZTtBQUFBLG9CQUNVLEtBQUs5QixLQURmO0FBQUEsVUFDTitCLElBRE0sV0FDTkEsSUFETTtBQUFBLFVBQ0E5QixLQURBLFdBQ0FBLEtBREE7QUFBQSxVQUVWa0IsSUFGVSxHQUVILEVBQUVSLHNCQUFzQlYsTUFBTVMsS0FBOUIsRUFGRzs7O0FBSWQsVUFBSSxDQUFDcUIsSUFBTCxFQUFXO0FBQUUsZUFBT1osSUFBUDtBQUFjOztBQUUzQiwwQkFBWVksSUFBWixFQUFxQlosSUFBckIsSUFBMkJaLFNBQVMsbUJBQUl3QixJQUFKLEVBQVUsY0FBVixDQUFwQztBQUNEOzs7Z0NBRTRDO0FBQUEsVUFBM0JKLGlCQUEyQix1RUFBUCxLQUFPOztBQUMzQyxhQUNFLEVBQ0U7QUFDRUssZUFBTyxJQURUO0FBRUVDLGNBQU0sUUFGUjtBQUdFQyxtQkFBVztBQUhiLE9BREYsRUFNRTtBQUNFRixlQUFPLHNCQURUO0FBRUVHLGtCQUFVLElBRlo7QUFHRUYsY0FBTTtBQUhSLE9BTkYsRUFXRTtBQUNFRyx1QkFBZSxLQURqQjtBQUVFSixlQUFPLHNCQUZUO0FBR0VLLG1CQUFXLHNCQUhiO0FBSUVGLGtCQUFVLElBSlo7QUFLRUYsY0FBTTtBQUxSLE9BWEYsRUFrQkU7QUFDRUQsZUFBTyxlQURUO0FBRUVDLGNBQU07QUFGUixPQWxCRixFQXNCRTtBQUNFRCxlQUFPLFNBRFQ7QUFFRU0sb0JBQVksa0JBRmQ7QUFHRUwsY0FBTTtBQUhSLE9BdEJGLEVBMkJFO0FBQ0VELGVBQU8sT0FEVDtBQUVFQyxjQUFNO0FBRlIsT0EzQkYsNEJBK0JLLG9CQUFTTixpQkFBVCxFQUE0QjtBQUM3QkssZUFBTyxzQkFEc0I7QUFFN0JPLGVBQU8sMkJBRnNCO0FBRzdCSixrQkFBVSxJQUhtQjtBQUk3QkYsY0FBTTtBQUp1QixPQUE1QixDQS9CTCxHQURGO0FBd0NEOzs7O0VBcEVtQ08sZ0IsV0EyRjdCQyxZLEdBQWU7QUFDcEI1QjtBQURvQixDLFVBSWY2QixTLEdBQVk7QUFDakJ6QyxTQUFPMEMsb0JBQVVDLE1BREE7QUFFakJ6QyxhQUFXd0Msb0JBQVVDLE1BRko7QUFHakJoQixlQUFhZSxvQkFBVUMsTUFITjtBQUlqQmIsUUFBTVksb0JBQVVDLE1BSkM7QUFLakIxQyxhQUFXeUMsb0JBQVVDLE1BTEo7QUFNakIvQixXQUFTOEIsb0JBQVVFLElBTkY7QUFPakJDLGdCQUFjSCxvQkFBVUMsTUFQUDtBQVFqQnJCLFdBQVNvQixvQkFBVUM7QUFSRixDO2VBWU5oRCx1Qjs7Ozs7Ozs7Ozs7MEJBM0dUQSx1QiIsImZpbGUiOiJHZW5lcmljRnVuZGluZ0Zvcm1Nb2RhbC5qcyIsInNvdXJjZVJvb3QiOiIvYXBwIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IFJlYWN0LCB7IENvbXBvbmVudCB9IGZyb20gJ3JlYWN0JztcbmltcG9ydCBQcm9wVHlwZXMgZnJvbSAncHJvcC10eXBlcyc7XG5pbXBvcnQgeyBvYnNlcnZlciwgaW5qZWN0IH0gZnJvbSAnbW9ieC1yZWFjdCc7XG5pbXBvcnQgYXV0b0JpbmRNZXRob2RzIGZyb20gJ2NsYXNzLWF1dG9iaW5kLWRlY29yYXRvcic7XG5pbXBvcnQgeyBnZXQsIHN0dWJGYWxzZSB9IGZyb20gJ2xvZGFzaCc7XG5cbmltcG9ydCB7IEZvcm1Nb2RhbCB9IGZyb20gJy4uLy4uLy4uL2xpYi9taWdodHktZmllbGRzJztcbmltcG9ydCB7IGluc2VydElmIH0gZnJvbSAnLi4vLi4vLi4vdXRpbHMvdXRpbCc7XG5cbkBpbmplY3QoJ1VpU3RvcmUnLCAnTGllblN0b3JlJywgJ09wdGlvbnNTdG9yZScsICdDYXNlU3RvcmUnLCAnRnVuZGVyU3RvcmUnKVxuQGF1dG9CaW5kTWV0aG9kc1xuQG9ic2VydmVyXG5jbGFzcyBHZW5lcmljRnVuZGluZ0Zvcm1Nb2RhbCBleHRlbmRzIENvbXBvbmVudCB7XG4gIGFzeW5jIG9uU2F2ZSAoZm9ybURhdGEpIHtcbiAgICBjb25zdCB7IF9jYXNlLCBMaWVuU3RvcmUsIENhc2VTdG9yZSB9ID0gdGhpcy5wcm9wc1xuICAgICAgLCBsaWVuRGF0YSA9IHsgLi4uZm9ybURhdGEsIGNhc2U6IF9jYXNlLmlkLCBzdWJ0eXBlOiB7IG5hbWU6IGZvcm1EYXRhLnN1YnR5cGUgfSB9XG4gICAgICAsIGNhc2VEYXRhID0geyB2YWx1ZTogZm9ybURhdGEuZXN0aW1hdGVkX2Nhc2VfdmFsdWUgfVxuICAgICAgLCBpc0Nhc2VWYWx1ZVVwZGF0ZWQgPSBfY2FzZS52YWx1ZSAhPT0gY2FzZURhdGEudmFsdWU7XG5cbiAgICBpZiAoIWxpZW5EYXRhLnN1YnR5cGUubmFtZSkgeyBsaWVuRGF0YS5zdWJ0eXBlID0gbnVsbDsgfVxuXG4gICAgdGhpcy5vbkNsb3NlKCk7XG5cbiAgICBjb25zdCBwcm9taXNlcyA9IFtMaWVuU3RvcmUuY3JlYXRlT3JVcGRhdGVHZW5lcmljTGllbihsaWVuRGF0YSldO1xuICAgIGlmIChpc0Nhc2VWYWx1ZVVwZGF0ZWQpIHsgcHJvbWlzZXMucHVzaChDYXNlU3RvcmUudXBkYXRlKHsgY2FzZUlkOiBfY2FzZS5pZCwgZGF0YTogY2FzZURhdGEgfSkpOyB9XG4gICAgYXdhaXQgUHJvbWlzZS5hbGwocHJvbWlzZXMpO1xuXG4gICAgaWYgKGlzQ2FzZVZhbHVlVXBkYXRlZCkgeyBhd2FpdCBMaWVuU3RvcmUubGlzdCh7IGNhc2VJZDogX2Nhc2UuaWQgfSk7IH1cbiAgfVxuXG4gIGdldCBsaWVuRGF0YSAoKSB7XG4gICAgY29uc3QgeyBsaWVuLCBfY2FzZSB9ID0gdGhpcy5wcm9wc1xuICAgICAgLCBkYXRhID0geyBlc3RpbWF0ZWRfY2FzZV92YWx1ZTogX2Nhc2UudmFsdWUgfTtcblxuICAgIGlmICghbGllbikgeyByZXR1cm4gZGF0YTsgfVxuXG4gICAgcmV0dXJuIHsgLi4ubGllbiwgLi4uZGF0YSwgc3VidHlwZTogZ2V0KGxpZW4sICdzdWJ0eXBlLm5hbWUnKSB9O1xuICB9XG5cbiAgc3RhdGljIGZpZWxkU2V0cyAoaXNGaW5hbmNlQ3VzdG9tZXIgPSBmYWxzZSkge1xuICAgIHJldHVybiAoXG4gICAgICBbW1xuICAgICAgICB7XG4gICAgICAgICAgZmllbGQ6ICdpZCcsXG4gICAgICAgICAgdHlwZTogJ2hpZGRlbicsXG4gICAgICAgICAgd3JpdGVPbmx5OiB0cnVlLFxuICAgICAgICB9LFxuICAgICAgICB7XG4gICAgICAgICAgZmllbGQ6ICdlc3RpbWF0ZWRfY2FzZV92YWx1ZScsXG4gICAgICAgICAgcmVxdWlyZWQ6IHRydWUsXG4gICAgICAgICAgdHlwZTogJ21vbmV5JyxcbiAgICAgICAgfSxcbiAgICAgICAge1xuICAgICAgICAgIGNhbkNoYW5nZVR5cGU6IGZhbHNlLFxuICAgICAgICAgIGZpZWxkOiAnb3duZXJzaGlwX3BlcmNlbnRhZ2UnLFxuICAgICAgICAgIHBlcmNlbnRPZjogJ2VzdGltYXRlZF9jYXNlX3ZhbHVlJyxcbiAgICAgICAgICByZXF1aXJlZDogdHJ1ZSxcbiAgICAgICAgICB0eXBlOiAncGVyY2VudE1vbmV5JyxcbiAgICAgICAgfSxcbiAgICAgICAge1xuICAgICAgICAgIGZpZWxkOiAnYWNxdWlyZWRfZGF0ZScsXG4gICAgICAgICAgdHlwZTogJ2RhdGUnLFxuICAgICAgICB9LFxuICAgICAgICB7XG4gICAgICAgICAgZmllbGQ6ICdzdWJ0eXBlJyxcbiAgICAgICAgICBvcHRpb25UeXBlOiAnZ2VuZXJpY0xpZW5UeXBlcycsXG4gICAgICAgICAgdHlwZTogJ29wdGlvblNlbGVjdCcsXG4gICAgICAgIH0sXG4gICAgICAgIHtcbiAgICAgICAgICBmaWVsZDogJ25vdGVzJyxcbiAgICAgICAgICB0eXBlOiAndGV4dCcsXG4gICAgICAgIH0sXG4gICAgICAgIC4uLmluc2VydElmKGlzRmluYW5jZUN1c3RvbWVyLCB7XG4gICAgICAgICAgZmllbGQ6ICdpc19hdmFpbGFibGVfdG9fY29vcCcsXG4gICAgICAgICAgbGFiZWw6ICdBdmFpbGFibGUgVG8gQ29PcCBDYXBpdGFsJyxcbiAgICAgICAgICByZXF1aXJlZDogdHJ1ZSxcbiAgICAgICAgICB0eXBlOiAnYm9vbGVhbicsXG4gICAgICAgIH0pLFxuICAgICAgXV1cbiAgICApO1xuICB9XG5cbiAgb25DbG9zZSAoKSB7XG4gICAgY29uc3QgeyBVaVN0b3JlLCBvbkNsb3NlIH0gPSB0aGlzLnByb3BzO1xuICAgIG9uQ2xvc2UoKTtcbiAgICBVaVN0b3JlLm1vZGFscy5HZW5lcmljRnVuZGluZ0Zvcm0uY2xvc2UoKTtcbiAgfVxuXG4gIHJlbmRlciAoKSB7XG4gICAgY29uc3QgeyBGdW5kZXJTdG9yZTogeyBpc0ZpbmFuY2VDdXN0b21lciB9IH0gPSB0aGlzLnByb3BzO1xuXG4gICAgcmV0dXJuIChcbiAgICAgIDxGb3JtTW9kYWxcbiAgICAgICAgY2xhc3NOYW1lPSdmb3JtLWdlbmVyaWMtZnVuZGluZydcbiAgICAgICAgZmllbGRTZXRzPXtHZW5lcmljRnVuZGluZ0Zvcm1Nb2RhbC5maWVsZFNldHMoaXNGaW5hbmNlQ3VzdG9tZXIpfVxuICAgICAgICBtb2RlbD17dGhpcy5saWVuRGF0YX1cbiAgICAgICAgb25DbG9zZT17dGhpcy5vbkNsb3NlfVxuICAgICAgICBvblNhdmU9e3RoaXMub25TYXZlfVxuICAgICAgICB0aXRsZT0nTmV3IExpZW4nXG4gICAgICAvPlxuICAgICk7XG4gIH1cblxuICBzdGF0aWMgZGVmYXVsdFByb3BzID0ge1xuICAgIG9uQ2xvc2U6IHN0dWJGYWxzZSxcbiAgfVxuXG4gIHN0YXRpYyBwcm9wVHlwZXMgPSB7XG4gICAgX2Nhc2U6IFByb3BUeXBlcy5vYmplY3QsXG4gICAgQ2FzZVN0b3JlOiBQcm9wVHlwZXMub2JqZWN0LFxuICAgIEZ1bmRlclN0b3JlOiBQcm9wVHlwZXMub2JqZWN0LFxuICAgIGxpZW46IFByb3BUeXBlcy5vYmplY3QsXG4gICAgTGllblN0b3JlOiBQcm9wVHlwZXMub2JqZWN0LFxuICAgIG9uQ2xvc2U6IFByb3BUeXBlcy5mdW5jLFxuICAgIE9wdGlvbnNTdG9yZTogUHJvcFR5cGVzLm9iamVjdCxcbiAgICBVaVN0b3JlOiBQcm9wVHlwZXMub2JqZWN0LFxuICB9XG59XG5cbmV4cG9ydCBkZWZhdWx0IEdlbmVyaWNGdW5kaW5nRm9ybU1vZGFsO1xuIl19